import { EChartTimeseries } from "../../../components/EChartTimeseries.js";
import { useMemoizedBarSeries } from "../../../hooks/chart.js";
import { type BasicUsageChartProps, UsageChartWrapper } from "./UsageChartWrapper.js";
import { TieredPriceProductId } from "@project/common";
import { IconMessage2Down, IconMessage2Up } from "@tabler/icons-react";
import { checkIsApproachingLimit } from "./utils/limits.js";
import { useAssistantUsage } from "./hooks/fetchUsages.js";
import { useProductNames } from "./hooks/productLabels.js";

export function InputTokensUsageChart({ from, to, interval, addToDetailedView }: BasicUsageChartProps) {
  const getName = useProductNames();
  const {
    assistantUsage,
    isLoadingAssistantUsage,
    isErrorAssistantUsage,
  } = useAssistantUsage({ from, to, interval });

  const inputTokens = assistantUsage?.input ?? [];
  const inputTitle = getName(TieredPriceProductId.TieredInputToken);
  const inputSeries = useMemoizedBarSeries(inputTokens, inputTitle);

  return (
    <UsageChartWrapper
      title={inputTitle}
      iconColor="error.3"
      icon={<IconMessage2Up size={20} />}
      hasUsage={inputTokens.length > 0}
      hasError={isErrorAssistantUsage}
      addToDetailedView={addToDetailedView}
      isApproachingLimit={checkIsApproachingLimit(
        inputTokens,
        TieredPriceProductId.TieredInputToken,
      )}
      isLoading={isLoadingAssistantUsage}
    >
      <EChartTimeseries series={inputSeries} />
    </UsageChartWrapper>
  );
}

export function OutputTokensUsageChart({ from, to, interval, addToDetailedView }: BasicUsageChartProps) {
  const getName = useProductNames();
  const {
    assistantUsage,
    isLoadingAssistantUsage,
    isErrorAssistantUsage,
  } = useAssistantUsage({ from, to, interval });

  const outputTokens = assistantUsage?.output ?? [];
  const outputTitle = getName(TieredPriceProductId.TieredOutputToken);
  const outputSeries = useMemoizedBarSeries(outputTokens, outputTitle);

  return (
    <UsageChartWrapper
      title={outputTitle}
      icon={<IconMessage2Down />}
      iconColor="warning.3"
      hasUsage={outputTokens.length > 0}
      hasError={isErrorAssistantUsage}
      isLoading={isLoadingAssistantUsage}
      addToDetailedView={addToDetailedView}
      isApproachingLimit={checkIsApproachingLimit(
        outputTokens,
        TieredPriceProductId.TieredOutputToken,
      )}
    >
      <EChartTimeseries series={outputSeries} />
    </UsageChartWrapper>
  );
}
